<div class="searchResults mx-2-5 mb-2 pb-2rem">
  <div class="glossary_term_usage_heading">{{termUsageTitle}}</div>
  <div class="mt-1rem mb-1">{{termUsageDef}}</div>
  <div class="glossary_term_usage_heading fs-1-5rem pt-1" tabindex="0">{{termTitle}}</div>
  <div *ngIf="termData.length>0">
    <div *ngFor="let term of termData" class="mt_1 link-topic">
      <div *ngIf="term.termBody.topic != null && term.termBody.subtopic != null && term.termBody.section != null">
        <div class="searchTopicText bold">
          {{term.termBody.topic}}-{{term.termBody.subtopic}}-{{term.termBody.section}}
        </div>
        <a class="link mt-1rem display-list glossaryUsage searchTopicText font-16" (mouseover)="mouseOverFunctions($event, term)" (click)="navigateToContent($event, term.termBody.topicId, term.termBody)" (keyup.enter)="navigateToContent($event,  term.termBody.topicId, term.termBody)" tabindex="0">
          {{term.termBody.topic}}&nbsp;{{term.termBody.topicName}}&nbsp;
          > {{term.termBody.subtopic}}&nbsp;{{term.termBody.subtopicName}}
          > {{term.termBody.section}}&nbsp;{{term.termBody.sectionName}}
          <span *ngIf="term.termBody.paragraphName != null">
            >
            {{term.termBody.paragraphName}},&nbsp;Paragraph&nbsp;{{term.termBody.paragraph}}
          </span>
        </a>
      </div>
      <div *ngIf="term.termBody.topic == null && term.termBody.subtopic == null && term.termBody.section == null">
        <div class="searchTopicText bold">
          Master Glossary
        </div>
        <a class="link mt-1rem display-list glossaryGlossaryUsage searchTopicText font-16" (click)="gotoGlossary(term.termBody.paragraphTitle)" (keyup.enter)="gotoGlossary(term.termBody.paragraphTitle)" tabindex="0">
          {{term.termBody.paragraphTitle}}
        </a>
      </div>
      </div>
    </div>
  <div *ngIf="termData.length==0" class="pt-1-25">
    No Records Found.
  </div>
</div>
